import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import type { BreadcrumbItem } from './types'

export const useBreadcrumbs = () => {
    const location = useLocation()

    const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
        const pathnames = location.pathname.split('/').filter((x) => x)
        const crumbs: BreadcrumbItem[] = [
            {
                key: 'home',
                title: 'Главная',
                href: '/',
                clickable: true
            }
        ]

        pathnames.reduce((prev, curr) => {
            const href = `${prev}/${curr}`
            const title = getBreadcrumbTitle(curr, href)

            crumbs.push({
                key: href,
                title,
                href: href
            })

            return href
        }, '')

        return crumbs
    }, [location.pathname])

    return breadcrumbs
}

// Функция для получения заголовка и параметров breadcrumb
const getBreadcrumbTitle = (path: string, fullPath: string): string => {
    const titleMap: Record<string, string> = {
        profile: 'Профиль',
        'internet-resources': 'Интернет-ресурсы',
        posts: 'Постинг',
        scheduled: 'Запланированные',
        draft: 'Черновики',
        published: 'Опубликованные',
        advertising: 'Рекламный постинг',
        // tokens: 'Заявки на партнерство',
        partners: 'Партнеры',
        '/advertising/partners/new': 'Добавление',
        '/advertising/partners/:id': 'Редактирование',
        buy: 'Закуп',
        sell: 'Продажа',
        statistics: 'Статистика',
        settings: 'Настройки',
        referral: 'Реферальная программа',
        stock: 'Биржа Каналов',
        'sell-stock': 'Продать рекламу в канале',
        '/stock/buy-advertising': 'Рекламные предложения'
    }

    // Проверяем точное совпадение
    if (titleMap[path]) return titleMap[path]
    if (titleMap[fullPath]) return titleMap[fullPath]

    // Проверяем пути с параметрами
    for (const [key, value] of Object.entries(titleMap)) {
        const regex = new RegExp(`^${key.replace(/:[^/]+/g, '[^/]+')}$`)
        if (regex.test(fullPath)) {
            return value
        }
    }

    return 'Неизвестный маршрут'
}
